module.exports = __webpack_public_path__ + "img/planet.ca20aa68.png";